module.exports = __webpack_public_path__ + "static/it-landing-page-e2833cd4002591c2ff69f9d4531ff4d3.jpg";